import { render } from "./OKRCheckerStart.vue?vue&type=template&id=618d99ff&scoped=true&ts=true"
import script from "./OKRCheckerStart.vue?vue&type=script&lang=ts"
export * from "./OKRCheckerStart.vue?vue&type=script&lang=ts"

import "./OKRCheckerStart.vue?vue&type=style&index=0&id=618d99ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618d99ff"]])

export default __exports__